import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { COLORS } from 'src/styles/common';

interface IModalItemProps {
  label?: string | ReactNode;
  value: string | ReactNode;
  valueSx?: object;
  containerSx?: object;
  column?: boolean;
}

export const BlockchainModalItem = ({
  label,
  value,
  valueSx,
  containerSx,
  column
}: IModalItemProps) => {
  return (
    <Box id="index__components-blockchain-verified-banner-blockchain-modal-item__box__l21"
    sx={{
      pb: '10px',
      display: 'flex',
      flexDirection: column ? 'column' : 'row',
      gap: '5px',
      maxWidth: '100%',
      alignItems: column ? 'flex-start' : 'baseline',
      justifyContent: column ? 'center' : 'flex-start',
      ...containerSx
    }}>
      
      {label &&
      <Typography id="index__components-blockchain-verified-banner-blockchain-modal-item__typography__l34" sx={{ fontSize: '12px', fontWeight: 600, color: COLORS.GREY_LIGHT }}>
          {label}:
        </Typography>
      }
      <Typography id="index__components-blockchain-verified-banner-blockchain-modal-item__typography__l38" sx={{ fontSize: '16px', ...valueSx }}>{value}</Typography>
    </Box>);

};